/**
 * -----------------------------------------------------------------------------
 * It renders the envelop icon in dark gray color.
 */
export function EnvelopIcon() {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      width={20}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="stroke-stone-800"
        d="M2.5 4.375h15V15a.624.624 0 0 1-.625.625H3.125A.625.625 0 0 1 2.5 15V4.375Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="stroke-stone-800"
        d="M17.5 4.375 10 11.25 2.5 4.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
